import AppContent from './AppContent.vue'

export default AppContent
